import type { SecretaryMessagePayload } from '../types/chat'
import { isFrenchLanguage } from './chatUiLocale'

/** Align with backend ``response_localization._FR_SIGNAL`` (preview-only heuristic). */
const FR_CONTENT_RE =
  /[àâäéèêëïîôùûüçœæ]|\b(le|la|les|un|une|des|du|de|et|ou|avec|pour|vous|votre|cette|ce|cet|secrétaire|médecin|bonjour|bonsoir|salut|coucou|demandez|demander|envoyez|envoyer|rappelle|ouvrez|dites|quel|quelle|quels|quelles|veux|voulez|puis|faire|annuler|confirmer|rendez|rendez-vous|prendre|relance|radiographie|patient|appeler|vérifi|verifi|demain|matin|soir|auprès|aupres|montre(?:r|-moi|-z)?|affiche(?:r|-z)?|ouvre(?:z|r)?|ouvrir|ferme(?:z|r)?|fermer|lis(?:ez)?|lire|voir|consulte(?:r|-z)?|cherche(?:z|r)?|chercher|recherche(?:z|r)?|trouve(?:z|r)?|ecoute(?:z|r)?|dis(?:ez)?|non\s+lus|urgent|messagerie)\b/i

export function secretaryContentLooksFrench(text: string): boolean {
  const t = (text || '').trim()
  return Boolean(t && FR_CONTENT_RE.test(t))
}

function responseLangToFrench(responseLang?: string | null): boolean | undefined {
  const rl = (responseLang || '').trim().toLowerCase()
  if (rl === 'fr' || rl === 'french' || rl.startsWith('fr-')) return true
  if (rl === 'en' || rl === 'english') return false
  return undefined
}

export function resolveSecretaryPreviewFrench(
  sm: SecretaryMessagePayload | undefined,
  opts?: { responseLang?: string | null; backendFrench?: boolean },
): boolean | undefined {
  const subj = (sm?.subject || sm?.purpose || '').trim()
  const body = (sm?.message || sm?.object || '').trim()
  if (subj && body) {
    if (secretaryContentLooksFrench(subj) && secretaryContentLooksFrench(body)) return true
    if (!secretaryContentLooksFrench(subj) && !secretaryContentLooksFrench(body)) {
      if (opts?.backendFrench === true) return true
      if (opts?.backendFrench === false) return false
      return responseLangToFrench(opts?.responseLang)
    }
    if (opts?.backendFrench === true) return true
    if (opts?.backendFrench === false) return false
    return responseLangToFrench(opts?.responseLang)
  }
  const only = subj || body
  if (only) {
    if (secretaryContentLooksFrench(only)) return true
    if (opts?.backendFrench === true) return true
    if (opts?.backendFrench === false) return false
    return responseLangToFrench(opts?.responseLang)
  }
  if (opts?.backendFrench === true) return true
  if (opts?.backendFrench === false) return false
  return responseLangToFrench(opts?.responseLang)
}

export function secretaryPreviewFrenchFromPayload(
  sm: SecretaryMessagePayload | undefined,
  responseLang?: string | null,
): boolean | undefined {
  return resolveSecretaryPreviewFrench(sm, { responseLang })
}

export function secretaryPreviewFrFromMessage(m: {
  secretaryMessage?: SecretaryMessagePayload
  secretaryFrench?: boolean
}): boolean {
  const resolved = resolveSecretaryPreviewFrench(m.secretaryMessage, {
    backendFrench: m.secretaryFrench,
  })
  if (resolved === true) return true
  if (resolved === false) return false
  return isFrenchLanguage()
}
